import styled from "styled-components";

const Container = styled.div`
margin-top: 1.1rem;
&.hidden {
    display: none;
}
`

const ChannelList = styled.ul`
    min-height: fit-content;
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    grid-gap: 12px;
    max-width: 100%;
    
    li{
        &.hidden{
            display: none;
        }
        &.whatsapp{
            background-color: #53cd5e30;
            color: #53cd5e;
        }
        &.email{
            background-color: #ffca2830;
            color: #ffca28;
        }
        &.sms{
            background-color: #26c6da30;
            color: #26c6da;
        }
        &.messenger{
            background-color: #007ff730;
            color: #007ff7;
        }
        &.phone{
            background-color: #cd272130;
            color: #cd2721;
        }
        &.video{
            background-color: #108b7f30;
            color: #108b7f;
        }
        &.widget{
            background-color: #5739EA30;
            color: #5739EA;
        }
        &:not(.active){
            background-color: transparent;
            color: #E0E0E0;
            border: 1px solid currentColor;
        }
        span {
            font-size: .75rem;
        }
        border: 1px solid transparent;
        width: fit-content;
        padding: 8px 10px;
        max-height: 25px;
        svg {
            width: .85rem;
            height: .85rem;
            margin-right: .3rem;
        }
    }`

export {Container,ChannelList}